import { render, staticRenderFns } from "./product-price.vue?vue&type=template&id=9fa2bde2"
import script from "./product-price.vue?vue&type=script&lang=js"
export * from "./product-price.vue?vue&type=script&lang=js"
import style0 from "./product-price.vue?vue&type=style&index=0&id=9fa2bde2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports